import { immerable } from "immer";

export type ProductStockAvailabilityType = {
  requestedQuantity: number;
  fulfillableQuantity: number;
  availableContentsQuantity: number;
  caseContentsQuantity: number;
};

/**
 * 注文商品に対する在庫の充足状況
 *
 * 在庫消費のサジェスト(productSuggestedStockConsumptions)は注文数を完全に満たせない場合に
 * 空配列になるため、それだけでは「完品は作れないがバラ在庫はある」「注文数の一部のみ在庫あり」を
 * 区別できない。このモデルはその区別に必要な情報を保持する。
 */
export class ProductStockAvailability implements ProductStockAvailabilityType {
  [immerable] = true;

  requestedQuantity = 0;
  fulfillableQuantity = 0;
  availableContentsQuantity = 0;
  caseContentsQuantity = 0;

  constructor(data: Partial<ProductStockAvailabilityType> = {}) {
    Object.assign(this, data);
  }

  /** 注文数を完全に満たせるか */
  isFullyFulfillable() {
    return this.fulfillableQuantity >= this.requestedQuantity;
  }

  /** 完品は作れないが、消費可能なバラ在庫が存在するか */
  isFragmentedOnly() {
    return this.fulfillableQuantity <= 0 && this.availableContentsQuantity > 0;
  }

  /** 注文数の一部のみ在庫があるか */
  isPartiallyFulfillable() {
    return (
      this.fulfillableQuantity > 0 &&
      this.fulfillableQuantity < this.requestedQuantity
    );
  }

  /** 消費可能な在庫が全く無いか */
  hasNoStock() {
    return this.availableContentsQuantity <= 0 && this.fulfillableQuantity <= 0;
  }
}
